import { connect } from 'react-redux';
import {
  isLastReview,
  getHasReviewsSection,
} from 'src/store/reviews/selectors';
import { isRating } from 'src/store/hotelRating/selectors';

import { hasFacts } from '../../store/selectors/hotel';
import { getHasAboutHotel } from '../../store/selectors/common';
import AboutHotelMobile from '../../components/AboutHotelMobile/AboutHotelMobile';

const mapStateToProps = (state) => ({
  hasRating: isRating(state),
  isLastReview: isLastReview(state),
  hasFacts: hasFacts(state),
  hasReviews: getHasReviewsSection(state),
  hasAboutHotel: getHasAboutHotel(state),
});

export default connect(mapStateToProps)(AboutHotelMobile);
